// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

// Objeto global para almacenar instancias
window.scSwipers = {};

export function init_sc_swipers(context = document) {
    
    window.scSwipers = window.scSwipers || {};

    jQuery(context).find('.sc-swiper').each(function (index) {

        const $swiper = jQuery(this);
        const options = $swiper.data('options') || {};
        const id = $swiper.attr('id') || `swiper-${index}`;

        // Si ya está inicializado, salir
        if (this.swiper) return;

        // Crear instancia y guardar
        const instance = new Swiper(this, options);
        window.scSwipers[id] = instance;

        // Hover to second slide (si aplica)
        if ($swiper.is('[data-hover-to-second="true"]') && window.matchMedia('(hover: hover)').matches) {
            const goMethod = options.loop ? 'slideToLoop' : 'slideTo';

            const toSecond = () => {
                if (instance.realIndex !== 1) instance[goMethod](1, 300);
            };
            const toFirst = () => instance[goMethod](0, 200);

            instance.el.addEventListener('mouseenter', toSecond);
            instance.el.addEventListener('mouseleave', toFirst);
        }
    });
}

jQuery(document).ready(function($) {

    init_sc_swipers();

    new Swiper('.mySwiperOurSpaces', {
        slidesPerView: 1.5,
        spaceBetween: 16,
        navigation: {
            nextEl: '.sc-swiper-button-next',
            prevEl: '.sc-swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 1.5,
                spaceBetween: 56,
            },
            1024: {
                slidesPerView: 2.5,
                spaceBetween: 56,
            },
        }
    });

    new Swiper('.mySwiperHowWeWork', {
        slidesPerView: 1.3,
        spaceBetween: 16,
        navigation: {
            nextEl: '.sc-swiper-button-next',
            prevEl: '.sc-swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 1.5,
                spaceBetween: 56,
            },
            1024: {
                slidesPerView: 1.5,
                spaceBetween: 56,
            },
        }
    });

    new Swiper('.mySwiperOutdoorLightning', {
        slidesPerView: 0.8,
        spaceBetween: 24,
        breakpoints: {
            768: {
                slidesPerView: 1.6,
            },
            1024: {
                slidesPerView: 3,
            },
        }
    });

    new Swiper('.mySwiperRelatedProducts', {
        slidesPerView: 1.6,
        spaceBetween: 24,
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },
        breakpoints: {
            768: {
                slidesPerView: 3.2,
            },
            1024: {
                slidesPerView: 3.5,
            },
        }
    });

    new Swiper('.mySwiperRelatedProductsArte', {
        slidesPerView: 'auto',
        spaceBetween: 24,
        freeMode: true,
        watchSlidesProgress: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
        },
    });

    new Swiper('.mySwiperProductFamily', {
        slidesPerView: 1.6,
        spaceBetween: 16,
        pagination: {
            el: ".progressbar",
            type: "progressbar",
        },
        breakpoints: {
            768: {
                slidesPerView: 1.6,
            },
            1024: {
                slidesPerView: 4.6,
            },
        }
    });

    new Swiper('.mySwiperPopularProducts', {
        slidesPerView: 1.6,
        spaceBetween: 24,
        pagination: {
            el: ".progressbar",
            type: "progressbar",
        },
        breakpoints: {
            768: {
                slidesPerView: 3.2,
            },
            1024: {
                slidesPerView: 2.5,
            },
        }
    });

});
